import type { JSX } from 'react';

import { RelatedMeetingNotesList } from '../HouseholdNotes/RelatedMeetingNotesList';
import type { EventNoteView } from './event-details-shared';

interface EventDetailsNotesSectionProps {
    notes: EventNoteView[];
    onNoteClick: (note: EventNoteView) => void;
}

export function EventDetailsNotesSection({ notes, onNoteClick }: EventDetailsNotesSectionProps): JSX.Element {
    return <RelatedMeetingNotesList notes={notes} onNoteClick={onNoteClick} />;
}
